export const workingTimeList = [
  // {
  //   id: 0.0,
  //   name: "0.0",
  // },
  {
    id: 0.5,
    name: "0.5",
  },
  {
    id: 1.0,
    name: "1.0",
  },
  {
    id: 1.5,
    name: "1.5",
  },
  {
    id: 2.0,
    name: "2.0",
  },
  {
    id: 2.5,
    name: "2.5",
  },
  {
    id: 3.0,
    name: "3.0",
  },
  {
    id: 3.5,
    name: "3.5",
  },
  {
    id: 4.0,
    name: "4.0",
  },
  {
    id: 4.5,
    name: "4.5",
  },
  {
    id: 5.0,
    name: "5.0",
  },
  {
    id: 5.5,
    name: "5.5",
  },
  {
    id: 6.0,
    name: "6.0",
  },
  {
    id: 6.5,
    name: "6.5",
  },
  {
    id: 7.0,
    name: "7.0",
  },
  {
    id: 7.5,
    name: "7.5",
  },
  {
    id: 8.0,
    name: "8.0",
  },
];

export const workingMinutesList = [
  {
    id: 0,
    name: "0",
  },
  {
    id: 10,
    name: "10",
  },
  {
    id: 20,
    name: "20",
  },
  {
    id: 30,
    name: "30",
  },
  {
    id: 40,
    name: "40",
  },
  { id: 50, name: "50" },
];
export const workingHoursList = [
  {
    id: 0,
    name: "0",
  },
  {
    id: 1,
    name: "1",
  },
  {
    id: 2,
    name: "2",
  },
  {
    id: 3,
    name: "3",
  },
  {
    id: 4,
    name: "4",
  },
  {
    id: 5,
    name: "5",
  },
  {
    id: 6,
    name: "6",
  },
  {
    id: 7,
    name: "7",
  },
  {
    id: 8,
    name: "8",
  },
  {
    id: 9,
    name: "9",
  },
  {
    id: 10,
    name: "10",
  },
  {
    id: 11,
    name: "11",
  },
  {
    id: 12,
    name: "12",
  },
];
